import { BitWriter } from '../flac/bitWriter';

// @ts-ignore
import { Transmuxer } from './muxJsFork/mp4/transmuxer';

import type { TransmuxerOps, TransmuxerData, MuxJsParsedTsPacket } from './transmuxTypes';

// According to the MPEG TS specs the values from 4-15 is "Reserved for future use"
export const MIMIR_TS_SEGMENT_DELIMITER_PID = 0x07;

// Create a packet only understood my mimir to know where to split the segments being
// passed to the transmuxer.
export function createMimirSegmentDelimiterPacket(): Uint8Array {
  const bitWriter = new BitWriter();
  // Sync byte
  bitWriter.writeBits(0x47, 8);
  // Transport error indicator (TEI)
  bitWriter.writeBits(0b0, 1);
  // Payload unit start indicator (PUSI)
  bitWriter.writeBits(0b0, 1);
  // Transport priority
  bitWriter.writeBits(0b1, 1);
  // PID
  bitWriter.writeBits(MIMIR_TS_SEGMENT_DELIMITER_PID, 13);
  // Transport scrambling control (TSC)
  bitWriter.writeBits(0b00, 2);
  // Adaptation field control
  bitWriter.writeBits(0b01, 2);
  // Continuity counter
  bitWriter.writeBits(0b0000, 4);

  bitWriter.zeroPadLastByteIfNeeded();
  const packetHeader = bitWriter.getBuffer();
  const packet = new Uint8Array(188);
  packet.set(packetHeader, 0);
  return packet;
}

/**
 * NOTE: This must only be used with byte streams which contains Mimir Segment
 * Delimiter TS packets. Without this packet present the entire incoming TS
 * byte streams will be put into one mp4 fragment. The current fragment is kept
 * in memory by MuxJS until it is complete this may cause the process to run
 * out of memory.
 */
export function createTsToFragmentedMp4TransformStream(): TransformStream<Uint8Array, Uint8Array> {
  let wroteInitSegment = false;

  // If we put in 128 MB of TS without getting a fragment out we
  // assume something has gone wrong upstream and that the TS stream
  // does not contain Mimir Segment Delimiter packets.
  const maxSegmentSize = 1024 * 1024 * 128;
  let currentSegmentSize = 0;

  const shouldAutoFlush = (tsPacket: MuxJsParsedTsPacket): boolean => {
    return tsPacket.pid === MIMIR_TS_SEGMENT_DELIMITER_PID;
  };

  const transmuxer : TransmuxerOps = new Transmuxer({ shouldAutoFlush }) as any;
  return new TransformStream<Uint8Array, Uint8Array>({
    start(controller) {
      transmuxer.on('data', (data: TransmuxerData) => {
        currentSegmentSize = 0;
        if (!wroteInitSegment) {
          controller.enqueue(data.initSegment);
          wroteInitSegment = true;
        }
        controller.enqueue(data.data);
      });
    },
    transform(bytes: Uint8Array) {
      currentSegmentSize += bytes.length;
      transmuxer.push(bytes);
      if (currentSegmentSize > maxSegmentSize) {
        throw new Error(`Max segment size reached while transmuxing TS stream to fragmented MP4 (maxSegmentSize=${maxSegmentSize}). Make sure the TS stream contains Mimir Segment Delimiter packets at the original segment boundaries`);
      }
    },
    flush() {
      transmuxer.flush(false);
    }
  });
}
